const accordion = (acc, firstItemActive = false) => {
    if (!acc) return;

    const slideUp = (el, siblingEl) => {
        el.classList.remove('active');
        el.querySelector('.accordion-item__button-label').innerText = acc.dataset.labelOpen;
        el.querySelector(`${siblingEl}`).style.maxHeight = 0;
    };

    const slideDown = (el, siblingEl) => {
        const current = el.querySelector(`${siblingEl}`);
        el.classList.add('active');
        el.querySelector('.accordion-item__button-label').innerText = acc.dataset.labelClose;
        current.style.maxHeight = `${current.scrollHeight}px`;
    };

    if (firstItemActive) {
        slideDown(acc.querySelector('.accordion-item'), '.accordion-item__text');
    }

    const accLogic = (target) => {
        const items = [...acc.querySelectorAll('.accordion-item')];
        const item = target.closest('.accordion-item');

        const activeItem = items.find(otherItem => otherItem !== item && otherItem.classList.contains('active'));
        if (activeItem) {
            slideUp(activeItem, '.accordion-item__text');
        }

        if (item.classList.contains('active')) {
            slideUp(item, '.accordion-item__text');
        } else {
            slideDown(item, '.accordion-item__text');
        }
    };

    acc.addEventListener('click', ({ target }) => {
        if (target.closest('.accordion-item')) {
            accLogic(target);
        }
    });
};

export default accordion;
